var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification",
    "data-name": "notification",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "notification-1",
    d: "M216.5,163.36V104.09a71.74,71.74,0,0,0-14.43-43.17,73.59,73.59,0,0,0-34.91-25.33l-.43-.15,0-.46A37.56,37.56,0,0,0,129.34.7h-.63A37.13,37.13,0,0,0,91.46,34.3l0,.46L91,34.9a72.58,72.58,0,0,0-51.46,69.18v59.27H16.71v61.72H90.63l.12.54a38.21,38.21,0,0,0,74.5,0l.12-.54h73.92V163.36ZM107.65,30.86a22.14,22.14,0,0,1,21.09-15.07h.58A22.4,22.4,0,0,1,150.46,31l.34,1-1.07-.1c-2.08-.18-4.22-.28-6.35-.28H112.6c-1.4,0-2.83.05-4.25.13l-1,.06ZM149.24,226a22.73,22.73,0,0,1-21.17,14.18h-.14A22.7,22.7,0,0,1,106.78,226l-.39-1h43.24ZM224.05,210H32V178.44H54.74V104.09c0-31.6,26-57.32,57.86-57.34h30.79c31.9,0,57.87,25.72,57.89,57.34v74.35h22.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.b90b45d8.svg";
export { ForwardRef as ReactComponent };